import React from 'react';

const ICTHubPage: React.FC = () => {
  return (
    <div style={{ paddingTop: '70px', minHeight: '100vh', padding: '120px 20px 80px' }}>
      <div style={{ maxWidth: '800px', margin: '0 auto', textAlign: 'center' }}>
        <h1 style={{ fontSize: '2.5rem', marginBottom: '20px', color: '#000' }}>
          New Wave ICT Hub Limited
        </h1>
        <p style={{ fontSize: '1.2rem', color: '#666', lineHeight: '1.6', marginBottom: '40px' }}>
          Delivering cutting-edge active and passive telecommunications devices and 
          infrastructure solutions to locations nationwide. Our expert team specializes 
          in modern ICT solutions that drive business growth and connectivity.
        </p>
        
        <div style={{ marginTop: '40px', textAlign: 'left', maxWidth: '600px', margin: '40px auto 0' }}>
          <h3 style={{ color: '#000', marginBottom: '20px', textAlign: 'center' }}>Our Services:</h3>
          
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '20px' }}>
            <div style={{ background: '#f8f9fa', padding: '20px', borderRadius: '8px' }}>
              <h4 style={{ color: '#000', marginBottom: '10px' }}>Telecommunications Infrastructure</h4>
              <p style={{ color: '#666', fontSize: '0.9rem' }}>Complete infrastructure solutions for telecommunications networks</p>
            </div>
            
            <div style={{ background: '#f8f9fa', padding: '20px', borderRadius: '8px' }}>
              <h4 style={{ color: '#000', marginBottom: '10px' }}>Network Solutions</h4>
              <p style={{ color: '#666', fontSize: '0.9rem' }}>Advanced networking systems and connectivity solutions</p>
            </div>
            
            <div style={{ background: '#f8f9fa', padding: '20px', borderRadius: '8px' }}>
              <h4 style={{ color: '#000', marginBottom: '10px' }}>ICT Consulting</h4>
              <p style={{ color: '#666', fontSize: '0.9rem' }}>Expert consulting for digital transformation initiatives</p>
            </div>
            
            <div style={{ background: '#f8f9fa', padding: '20px', borderRadius: '8px' }}>
              <h4 style={{ color: '#000', marginBottom: '10px' }}>Technology Integration</h4>
              <p style={{ color: '#666', fontSize: '0.9rem' }}>Seamless integration of modern technology solutions</p>
            </div>
          </div>
        </div>
        
        <div style={{ marginTop: '60px' }}>
          <a 
            href="/#contact" 
            style={{ 
              background: '#000', 
              color: '#fff', 
              padding: '12px 24px', 
              borderRadius: '8px', 
              textDecoration: 'none',
              fontSize: '1rem',
              fontWeight: '500'
            }}
          >
            Get In Touch
          </a>
        </div>
      </div>
    </div>
  );
};

export default ICTHubPage;
